function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.9836 2.28571H9.91667V0.571429C9.91667 0.419876 9.85521 0.274531 9.74581 0.167368C9.63642 0.0602039 9.48804 0 9.33333 0H4.66667C4.51196 0 4.36358 0.0602039 4.25419 0.167368C4.14479 0.274531 4.08333 0.419876 4.08333 0.571429V2.28571H0.0164061L0 3.71429H1.20312L1.93557 14.9286C1.95411 15.2186 2.08472 15.4908 2.30083 15.6898C2.51694 15.8888 2.80233 15.9998 3.09896 16H10.901C11.1975 16 11.4828 15.8894 11.699 15.6907C11.9153 15.492 12.0462 15.2202 12.0652 14.9304L12.7969 3.71429H14L13.9836 2.28571ZM4.08333 13.7143L3.75521 4.57143H4.95833L5.28646 13.7143H4.08333ZM7.58333 13.7143H6.41667V4.57143H7.58333V13.7143ZM8.45833 2.28571H5.54167V1.28571C5.54167 1.24783 5.55703 1.21149 5.58438 1.1847C5.61173 1.15791 5.64882 1.14286 5.6875 1.14286H8.3125C8.35118 1.14286 8.38827 1.15791 8.41562 1.1847C8.44297 1.21149 8.45833 1.24783 8.45833 1.28571V2.28571ZM9.91667 13.7143H8.71354L9.04167 4.57143H10.2448L9.91667 13.7143Z",
  fill: "#DB8070"
});

function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDeleteIcon;